<template>
  <div class="author-logo__wrapper">
    <a-image
      v-if="src"
      :src="src"
      :alt="altText"
      :container-aspect-ratio="$options.consts.aspectRatios.userPhoto"
      :width="$options.consts.IMAGE_WIDTH"
      :srcset-location="$options.consts.SRCSET_LOCATION.AUTHOR_PAGE"
      :viewport-optimization="true"
      class="author-logo__logo"
    />
    <div v-else class="author-logo__default-logo-container">
      <a-image
        :src="defaultLogoSrc"
        :alt="altText"
        :container-aspect-ratio="$options.consts.aspectRatios.userPhoto"
        :width="$options.consts.DEFAULT_IMAGE_WIDTH"
        :viewport-optimization="true"
        class="author-logo__default-logo"
      />
    </div>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { DEFAULT_AUTHOR_LOGO } from 'enums/aws-files'
import { aspectRatios } from 'enums/aspectRatios'
import { SRCSET_LOCATION } from 'enums/images'

export default {
  name: 'AuthorLogo',
  props: {
    src: propValidator([PROP_TYPES.STRING], false),
    altText: propValidator([PROP_TYPES.STRING], false)
  },
  consts: {
    aspectRatios,
    IMAGE_WIDTH: 320,
    DEFAULT_IMAGE_WIDTH: 80,
    SRCSET_LOCATION
  },
  computed: {
    defaultLogoSrc() {
      return this.$helper.getLinkToFmBucketFile(DEFAULT_AUTHOR_LOGO)
    }
  }
}
</script>

<style lang="scss" scoped>
.author-logo__wrapper {
  width: 320px;
  max-width: 320px;
  height: 320px;
  flex-shrink: 0;
  background: rgba($c--black, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;

  @include mobile {
    width: 200px;
    max-width: 200px;
    height: 200px;
    margin: 20px auto;
  }

  .author-logo__logo {
    width: 100%;
    height: 100%;
  }

  .author-logo__default-logo-container {
    width: 80px;
    max-width: 80px;
    height: 105px;

    @include mobile {
      width: 55px;
      max-width: 55px;
      height: 73px;
    }
  }

  .author-logo__default-logo {
    width: 100%;
    height: 100%;
  }
}
</style>
